import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate } from "react-router-dom";
import { Avatar, Box, Button, ButtonGroup, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Select, MenuItem, Paper, Tabs, Tab } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import moment from "moment";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import { useSelector } from "react-redux";
import FormDialog from "src/components/common/FormDialog";
import NavBack from "src/components/common/NavBack";
import { IMG_BASE_URL, USER_LEVELS, USER_LEVEL_MAP, USER_STATUS, USER_STATUS_MAP, USER_TITLES, USER_TITLE_MAP } from "src/config/constants";
import { Switch } from "@mui/material";
import { asyncRequest } from "src/services/network";
import Cascader from "src/components/cascader/Cascader";
import { getAreas } from "src/services/request";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
// ----------------------------------------------------------------------

const levels = Object.values(USER_LEVELS);
const statusList = Object.values(USER_STATUS);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function Customer({ user }) {
  const [form, setForm] = useState({
    mobile: user ? user.mobile : "",
    orgId: user ? user.orgId : null,
    status: user ? user.status : 1,
    blocked: user ? !!user.blocked : false,
  });

  const [categoryTree, setCategoryTree] = useState([]);

  useEffect(() => {
    // getCategories(true);
  }, []);

  async function getCategories() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/user/org/all",
    });

    setCategoryTree(data);
  }

  useEffect(() => {
    if (!user) return;
    setForm({
      mobile: user.mobile || "",
      status: user.status != undefined ? user.status : 1,
      blocked: !!user.blocked,
    });
  }, [user]);

  if (!user) return null;

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  const { nickname, avatar, uid, points, balance, pointsGreen, createdAt } = user;

  async function handleSubmit() {
    const { msg } = await asyncRequest({
      path: "/user/edit",
      data: {
        mobile: form.mobile,
        status: form.status,
        orgId: form.orgId,
        uid: user.uid,
      },
    });

    alert(msg, "success");
  }

  async function handleToggleBlocked() {
    const { msg } = await asyncRequest({
      path: "/user/block",
      data: { uid: user.uid },
    });
    const next = !form.blocked;
    setForm({ ...form, blocked: next });
    user.blocked = next;
    alert(msg || (next ? "已禁止登录" : "已解除禁止登录"), "success");
  }

  return (
    <>
      <FormItem title="会员">
        {/* <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar alt={nickname} src={avatar} />
          <Typography variant="subtitle2" noWrap>
            {nickname}
          </Typography>
        </Stack> */}
        <UserInfo {...(user || {})}/>
      </FormItem>

      <FormItem title="手机号">
        <TextField fullWidth placeholder="手机号" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
      </FormItem>

      <FormItem title="积分">
        <TextField fullWidth disabled placeholder="积分" autoComplete="off" id="points" value={points} size="small" onChange={(e) => handleIptChange("points", e.target.value)} />
      </FormItem>

      <FormItem title="消费券">
        <TextField fullWidth disabled placeholder="消费券" autoComplete="off" id="balance" value={balance} size="small" onChange={(e) => handleIptChange("balance", e.target.value)} />
      </FormItem>

      {/* <FormItem title="职位">
        <TreeSelect
          data={categoryTree}
          value={form.orgId}
          onChange={v => handleIptChange("orgId", v)}
          topLabel="顶级菜单"
        />
      </FormItem> */}

      <FormItem title="状态">
        <Select value={form.status} onChange={(e) => handleIptChange("status", e.target.value)} style={{ width: 250, height: 44 }}>
          {statusList.map((s, idx) => (
            <MenuItem key={idx} value={s} name={s}>
              {USER_STATUS_MAP[s]}
            </MenuItem>
          ))}
        </Select>
      </FormItem>

      <FormItem title="禁止登录" alignItems="center">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Switch
            checked={!!form.blocked}
            color="error"
            onChange={handleToggleBlocked}
          />
          <Typography variant="body2" color={form.blocked ? "error" : "text.secondary"}>
            {form.blocked ? "已禁止（任意端无法登录）" : "未禁止"}
          </Typography>
        </Stack>
      </FormItem>

      <FormItem title="注册时间" alignItems="center">
        <Typography component="span">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</Typography>
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth minRows={5} multiline={true} placeholder="简单说明会员（选填）" autoComplete="off" id="remark" value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>

      <FormItem>
        <Button variant="contained" onClick={handleSubmit}>
          保存
        </Button>
      </FormItem>
    </>
  );
}

function Reseller({ user, onInfoChanged }) {
  const { areas, areaHierarchy } = useSelector((state) => state.globalData);
  const [showPicker, setShowPicker] = useState(false);

  const [area, setArea] = useState("");

  const [form, setForm] = useState({
    level: user.level || 0,
    isGzs: user.isGzs || false,
    agentCode: user.agentCode,
  });

  useEffect(() => {
    getAreas();
  }, []);

  useEffect(() => {
    if (!areas || !form.agentCode) return;
    const area = areas.find((area) => area.id === form.agentCode);

    setArea(area.name);
  }, [form.agentCode, areas]);

  if (!user) return null;

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function toggleDialog() {
    setShowPicker(!showPicker);
  }

  // 更改上级
  async function handleChangeParent(pid) {
    const { msg } = await asyncRequest({
      path: "/agent/changeparent",
      data: {
        uid: user.uid,
        pid,
      },
    });

    // navigate("/teacher/list", { replace: true });
    setShowPicker(false);
    onInfoChanged({ pid });
    alert(msg, "success");
  }

  async function handleSubmit() {
    const { msg } = await asyncRequest({
      path: "/user/edit",
      data: {
        ...form,
        uid: user.uid,
      },
    });

    alert(msg, "success");
  }

  const { commission, pid } = user;

  const parent = user.parent;

  console.log(parent);

  function onSelectParent() {
    UserPicker({
      onSelect(v) {
        handleChangeParent(v.uid);
      },
    });
  }

  return (
    <>
      <FormItem title="上级分销商" alignItems="center">
        {!parent ? (
          <Typography>暂未设置上级</Typography>
        ) : (
          <Stack direction="row" alignItems="center" spacing={2}>
            <UserInfo {...parent} />
          </Stack>
        )}
      </FormItem>

      <FormItem title="累计佣金" alignItems="center">
        <Typography>{commission}元</Typography>
      </FormItem>

      <FormItem title="代理">
        <Select value={form.level} onChange={(e) => handleIptChange("level", e.target.value)} style={{ width: 250, height: 44 }}>
          {levels.map((level, idx) => (
            <MenuItem key={idx} value={level} name={level}>
              {USER_LEVEL_MAP[level]}
            </MenuItem>
          ))}
        </Select>
        <TextField disabled value={area} />

        {!!areas && (
          <Cascader
            options={areaHierarchy}
            kiLabel="name"
            onNodeClick={(idx, v) => {
              // console.log(idx, v);

              setForm({
                ...form,
                level: 3 - idx,
                agentCode: v.value,
              });
              // handleIptChange("level", e.target.value)
            }}
            onSelect={(v) => {
              setForm({
                ...form,
                level: 1,
                agentCode: v[2].value,
              });
            }}
          />
        )}
      </FormItem>

      <FormItem>
        <Button variant="contained" onClick={handleSubmit}>
          保存
        </Button>
      </FormItem>
    </>
  );
}

export default function UserDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const [category, setCategory] = useState({});
  const [tab, setTab] = useState(0);
  const [users, setUsers] = useState(null);
  const [user, setUser] = useState(null);

  const [form, setForm] = useState({
    name: "",
    uid: null,
    nickname: "",
    mobile: "",
    username: "",
    password: "",
    image: "", // 封面
    share: "20",
    status: 0,
    remark: "",
  });

  useEffect(() => {
    if (!params.uid) return;

    axios
      .get(`/user/one/${params.uid}`)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setUser(data);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    // getUsers();
  }, []);

  function getUsers() {
    if (users) return;

    axios
      .get("/user/allshort")
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setUsers(data);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSubmit() {
    if (params.id) {
      editTeacher();
    } else {
      addTeacher();
    }
  }

  function editTeacher() {
    axios
      .post("/teacher/update", {
        ...form,
        desc: JSON.stringify(form.desc),
      })
      .then((res) => {
        console.log(res.data);
        const { code, msg, data } = res.data;
        if (code === 1) {
          navigate("/teacher/list", { replace: true });
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("editTeacher err: ", err);
      });
  }

  function addTeacher() {
    axios
      .post("/teacher/add", {
        ...form,
        desc: JSON.stringify(form.desc),
      })
      .then((res) => {
        console.log(res);
        const { code, msg, data } = res.data;
        if (code === 1) {
          navigate("/teacher/list", { replace: true });
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加教师出错: ", err);
      });
  }

  function handleTabChange(e, val) {
    // console.log(val)
    setTab(val);
  }

  function handleInfoChange(info) {
    setUser({
      ...user,
      ...info,
    });
  }

  return (
    <Page title="会员详情">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title="用户详情"></NavBack>
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tab} onChange={handleTabChange} aria-label="basic tabs example">
              <Tab label="会员信息" />
              <Tab label="分销商信息" />
              {/* <Tab label="Item Three" /> */}
            </Tabs>
          </Box>
          <TabPanel value={tab} index={0}>
            <Customer user={user} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <Reseller user={user} onInfoChanged={handleInfoChange} />
          </TabPanel>
        </Paper>
      </Container>
    </Page>
  );
}
